import { http } from "../../utils/config";

/**
 * ADMIN đổi mật khẩu cho tài khoản chủ đơn vị (SHOP).
 *
 * Ba hàm cũ ở file này (`getInfoUser`, `getAllUser`, `getUserShop`) đã chuyển vào
 * `auth/session.js` thành `loadUser` / `loadAllUser` / `loadUserShop` — chúng ghi
 * vào state dùng chung nên thuộc về store, không phải một module api rời.
 */
export const adminResetShopPassword = (id, password) =>
  http.put(`/auth/api/v1/admin/shops/${id}/reset-password`, { password });
